export const setItem = (key, value, expire) => {
  if (value === undefined || value === '') value = null // 防止取值转化报错
  const data = { value }
  expire && (data.expire = Date.now() + expire)
  window.localStorage.setItem(key, JSON.stringify(data))
}

export const getItem = key => {
  let data = JSON.parse(window.localStorage.getItem(key))
  if (!data) return null
  const { expire = '', value = {} } = data
  if (!expire || Date.now() < expire) return value
  window.localStorage.removeItem(key)
  return null
}
